import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import authRoutes from '../modules/auth/routes';
import dashboardRoutes from '../modules/dashboard/routes';
import salesRoutes from '../modules/sales/routes';
import salesPrintRoutes from '../modules/sales/printRoutes';
import formRoutes from '../modules/forms/routes';
import CompanyRoutes from '../modules/company/routes';
import employeeRoutes from '../modules/employee/routes';
import erpDeliveryRoutes from '../modules/erpDelivery/routes';
import crmRoutes from '../modules/crm/routes';
import warehouseRoutes from '../modules/warehouse/routes';
import cycleCountRoutes from '../modules/cycleCount/routes';
import creditPaymentRoutes from '../modules/creditPayments/routes';
import purchaseRoutes from '../modules/purchases/routes';
import posTerminalRoutes from '../modules/posTerminal/routes'; // POS-terminal (Plan B)
import posTillRoutes from '../modules/posTerminal/tillRoutes'; // POS-terminal (Plan B): full-screen till
import accessControlRoutes from '../modules/accessControl/routes';
import inventoryRoutes from '../modules/inventory/routes';
import ecommerceRoutes from '../modules/ecommerce/routes';

const ControlPanel = lazy(() => import('../modules/controlPanel/pages/ControlPanel'));
const CrmResultsPage = lazy(() => import('../modules/crm/pages/CrmResultsPage'));

// Protected routes that should be inside the MainLayout
export const protectedRoutes: RouteObject[] = [
  {
    path: 'control-panel',
    element: <ControlPanel />,
  },
  {
    path: 'dashboard',
    children: dashboardRoutes,
  },
  {
    path: 'sales',
    children: salesRoutes,
  },
  {
    path: 'forms',
    children: formRoutes,
  },  
  {
    path: 'companies',
    children: CompanyRoutes,
  },
  {
    path: 'employees',
    children: employeeRoutes,
  },
  {
    path: 'crm',
    children: crmRoutes,
  },
  {
    path: 'warehouse',
    children: warehouseRoutes,
  },
  // ERP Delivery Module - All delivery management routes
  ...erpDeliveryRoutes,
  {
    path: 'cycle-counting',
    children: cycleCountRoutes,
  },
  {
    path: 'credit-payments',
    children: creditPaymentRoutes,
  },
  {
    path: 'purchases',
    children: purchaseRoutes,
  },
  {
    path: 'pos', // POS-terminal (Plan B): POS Terminal admin
    children: posTerminalRoutes,
  },
  {
    path: 'inventory',
    children: inventoryRoutes,
  },
  {
    path: 'ecommerce',
    children: ecommerceRoutes,
  },
  {
    path: 'access-control',
    children: accessControlRoutes,
  },
];

// Public routes (login, company selection)
export const publicRoutes: RouteObject[] = [
  ...authRoutes,
  // CRM Results page - standalone without layout for printing
  {
    path: '/crm-results',
    element: <CrmResultsPage />,
  },
];

// Routes that need auth (token/branch) but must render WITHOUT MainLayout —
// standalone, directly-linkable/refreshable print & report pages. This is
// the standing convention for all printing going forward (see CLAUDE.md).
export const printRoutes: RouteObject[] = [
  ...salesPrintRoutes,
  ...posTillRoutes, // POS-terminal: /pos/till, /pos/receipt/:autoId
];
